import { Capacitor } from '@capacitor/core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-back-button',
  templateUrl: './custom-back-button.component.html',
  styleUrls: ['./custom-back-button.component.scss']
})
export class CustomBackButtonComponent implements OnInit {
  @Input() isNewSchedule = false;
  @Input() saveButtonEnabled = false;

  platform = Capacitor.getPlatform();
  get isiOS(): boolean {
    return this.platform === 'ios' ;
  }

  constructor() { }

  ngOnInit(): void {
  }

}
